module.exports = __webpack_public_path__ + "img/bpm-11.2f27d39a.jpg";